export * from './SmoothScrollNavigation'
// Not creating a story for this component because there's a problem with
// storybook and the smooth scroll that we are not able to solve
